import { Menu, Tag } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import { ISidebarItem } from '../../../types';
import { SidebarIcon } from './side-bar-icon';
const { SubMenu } = Menu;

const disabledStyles = {
	color: '#999',
	cursor: 'not-allowed'
};

export const renderSidebar = (menuItems: ISidebarItem[], keyPrefix: string | null = null, collapsed = false) => {
	return menuItems.map((item, indx) => {
		if (!item.submenu) {
			return (
				<Menu.Item
					key={`${keyPrefix ? `${keyPrefix}/${item.key || indx}` : item.key || indx}`}
					{...(item.props || {})}
				>
					<Link
						to={`${item.prefix !== false && keyPrefix ? `${keyPrefix}/${item.key}` : item.key}`}
						onClick={
							item.disabled
								? e => {
										e.preventDefault();
										e.stopPropagation();
								  }
								: item.props?.onClick
								? e => {
										e.preventDefault();
										item.props.onClick(e);
								  }
								: undefined
						}
						style={item.disabled ? { ...disabledStyles } : {}}
					>
						<div className="d-flex align-items-center">
							{item.icon ? <SidebarIcon disabled={item.disabled}>{item.icon}</SidebarIcon> : null}
							<span style={{ display: 'inline-block', marginLeft: collapsed ? '1.8rem' : '0.6rem' }}>
								{item.name}
							</span>
							{item.tags && item.tags.length
								? item.tags.map(tag => (
										<Tag key={tag.text} color={tag.bgColor} style={{ marginLeft: '10px' }}>
											<span style={{ color: tag.textColor, fontSize: '11px' }}>{tag.text}</span>
										</Tag>
								  ))
								: null}
						</div>
					</Link>
				</Menu.Item>
			);
		} else {
			return (
				<SubMenu
					key={item.key}
					title={
						<div className="d-flex align-items-center">
							<SidebarIcon> {item.icon}</SidebarIcon>
							<span style={{ display: 'inline-block', marginLeft: collapsed ? '1.8rem' : '0.6rem' }}>
								{item.name}
							</span>
						</div>
					}
				>
					{renderSidebar(item.submenu, keyPrefix ? `${keyPrefix}/${item.key}` : item.key)}
				</SubMenu>
			);
		}
	});
};
